//dependencies
import 'dotenv/config';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import axios from 'axios';

//resources
import { theMovieDbUrl } from './services/resourceURLs';
import { tmdbUrl } from './services/resourceURLs';

//components
import About from './components/footer/about/About.js';
import Contact from './components/footer/contact/Contact';
import Footer from './components/footer/Footer';
import Home from './components/home/Home';
import MovieRev from './components/movieReviews/MovieRev';
import MyReviews from './components/myReviews/MyReviews';
import Navigation from './components/navbar/ProductionNavigation';
import PremiumView from './components/premium/PremiumView';
import Privacy from './components/footer/privacy/Privacy';
import ratingStars from './components/stars/ratingStars';
import ReviewForm from './components/myReviews/ReviewForm';
import SearchResults from './components/home/Hero/SearchResults';
import Terms from './components/footer/terms/Terms';

//css
import './App.css';


class App extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          movies: [],
          random: '',
          randomTitle: '',
          randomArr: [],
          inputCriteria: '',
          searchCriteria: '',
          searchResults: [],
          loading: true
        }
      }

    componentDidMount = () => {
        console.log("start cdm")
        this.getMoviesAndPopularRandomMovie();
        console.log("end cdm")
    }

    randomNumber = (arr) => {
        return Math.floor(Math.random() * arr.length);
    }

    getReleaseYear = (string) => {
        if(!string) {
          return '';
        }
        let regex = /(18|19|20)\d{2}/g;
        let found = string.match(regex);
        if (!found) {
          return '';
        }
        return '(' + found + ')';
    }

    handleChange = (event) => {
      this.setState({[event.target.name ] : event.target.value});
    }

    searchHandler = (criteria) => {
      console.log(criteria, "criteria search handler")
      const url = `${theMovieDbUrl}/3/search/movie?api_key=${
        process.env.REACT_APP_API
      }&language=en-US&query=${criteria}&include_adult=false`
      console.log(url, "url\n")

        let promise = axios.get(
          url
        );
        promise
          .then(response => {
            console.log(response.data, "response.data\n")
            const { results } = response.data;
            console.log("results from App.js search handler", results);
            return this.setState({
              searchResults: results,
              searchCriteria: '',
              inputCriteria: '',
              loading: false
            })
          })
          .catch(err => {
            console.log(err.message);
          });
    }

    getMoviesAndPopularRandomMovie = () => {
      console.log(this.props, "props\n", this.state, "state\n")
      const promise = axios.get(
        `${theMovieDbUrl}/3/movie/popular?api_key=${
          process.env.REACT_APP_API
        }&language=en-US&page=1&include_adult=false`
      );
      promise
        .then(response => {
            console.log(response.data, "response.data\n")
            const { results } = response.data;
            const random = this.randomNumber(results);
            const { title, backdrop_path } = results[random];
            const movieTitle = title;
            const backdropURL =`${tmdbUrl}${backdrop_path}`;
            const randomArr = results.concat().sort(() => {
                return 0.5 - Math.random();
            });
            const start = Math.floor(Math.random() * 12);
            const end = start + 8;
            console.log(results, "results\n", title, "title\n", backdropURL, "backdropURL");
            this.setState({
              movies: results.movies, 
              randomTitle: movieTitle,
              random: backdropURL,
              randomArr: randomArr.slice(start, end),
              loading: false
            })
        })
        .catch(err => {
          console.log(err.message)
          throw new Error({Error: err.message});
        });
        
      }
      render() {
//loading state keeps static HTML from showing
if (this.state.loading) {
  return (
    <div>
      <h1>Loading...</h1> 
    </div>
  );
}

return (
  <div className="App-body">
    <div className="main">
      <Route render={props => (
        <Navigation
          {...props}
          handleChange={this.handleChange}
          loading={this.state.loading}
          searchHandler={this.searchHandler}
          inputCriteria={this.state.inputCriteria}
          searchResults={this.state.searchResults}
        />
      )} 
      />
      {/* exact path limits the page from rendering to 
      anything other than the path mentioned */}
      <Switch>
        <Route
          exact
          path="/"
          render={props => (
              <Home 
              {...props}
              movies={this.state.movies}
              loading={this.state.loading}
              randomBackgroundImage={this.state.random}
              randomArr={this.state.randomArr}
              randomTitle={this.state.randomTitle}
              getReleaseYear={this.getReleaseYear}
              handleChange={this.handleChange}
              searchHandler={this.searchHandler}
              searchResults={this.state.searchResults}
              searchCriteria={this.state.searchCriteria}
            />
          )}
        />
        {/* Route goes to the search query - passed props through route
        so that I wouldn't have to do it through Link on component file*/}
        <Route
          path={`/search`}
          render={props => (
            <SearchResults
              {...props}
              movies={this.state.movies}
              loading={this.state.loading}
              randomBackgroundImage={this.state.random}
              randomTitle={this.state.randomTitle}
              getReleaseYear={this.getReleaseYear}
              handleChange={this.handleChange}
              searchHandler={this.searchHandler}
              searchResults={this.state.searchResults}
              searchCriteria={this.state.searchCriteria}
            />
          )}
        />
        <Route path="/myreviews" 
          render={props => (
            <MyReviews
              {...props}
              getReleaseYear={this.getReleaseYear}
              />
          )} 
        />

        <Route path="/reviewform/:id" component={ReviewForm} />
        <Route path="/moviereviews/:id" component={MovieRev} />
        <Route path="/premium" component={PremiumView} />
        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms" component={Terms} />
        <Route path="/stars" component={ratingStars} />
      </Switch>
    </div>
    <div className="footer">
      <Footer />
    </div>        
  </div>
);
      }
      
};







  

export default App;
